export type Maybe<Type> = Type | undefined;

export const allowedStyleDeclarations = [
  "borderRadius",
  "backgroundColor",
  "color",
  "cursor",
  "fontFamily",
  "fontSize",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "userSelect",
  "border",
] as const;

export const allowedPseudoClasses = [
  ":focus",
  ":hover",
  ":invalid",
  ":valid",
] as const;

export type AllowedPseudoClasses = (typeof allowedPseudoClasses)[number];

export type ArrayElement<Array_> = Array_ extends readonly (infer Type)[]
  ? Type
  : never;

// The allowed [CSS Properties](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Properties_Reference) for styles to be passed into the iframe.
// Use the JavaScript casing, for example, `fontFamily` not `font-family`.
export type AllowedStyleOptions = Partial<
  Pick<CSSStyleDeclaration, ArrayElement<typeof allowedStyleDeclarations>>
>;
export type AllowedPseudoClassStyleOptions = Partial<
  Record<AllowedPseudoClasses, AllowedStyleOptions>
>;

export type AllowedFrameStyle =
  | AllowedPseudoClassStyleOptions
  | AllowedStyleOptions;

export type ClientToken = string;
export type PaymentCardId = string;

export const allowedHighnoteEnvironments = ["live", "test"] as const;
// The environment to use for making requests to the Highnote API.
//
// Read more here: https://highnote.com/docs/basics/build-and-launch/test-environment
//
export type HighnoteEnvironment = (typeof allowedHighnoteEnvironments)[number];

export interface HighnotePostMessageEvent<EventType> {
  uuid: string;
  data: EventType;
}

export * from "./error";
export * from "./cardViewer";
export * from "./secureInputs";
export * from "./riskApplicationSdk";
export * from "./documentUploadSdk";
export * from "./checkout";
